/**
 * Priority levels for notifications.
 * Determines delivery channels and urgency.
 */
export enum NotificationPriority {
  CRITICAL = 'critical',
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
}
